import { BasicDialog } from "./BasicDialog";
import { useLanguage } from "@/contexts/LanguageContext";

interface DiscardChangesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDiscard: () => void;
}

/**
 * Preset dialog for confirming discard of unsaved changes.
 * Used exclusively by Overlay/Sheet close guards.
 */
export function DiscardChangesDialog({
  open,
  onOpenChange,
  onDiscard,
}: DiscardChangesDialogProps) {
  const { t } = useLanguage();

  return (
    <BasicDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t("common.discardChanges.title")}
      description={t("common.discardChanges.description")}
      tone="destructive"
      closeOnOutsideClick={false}
      dismiss={{
        label: t("common.discardChanges.keepEditing"),
        onClick: () => onOpenChange(false),
      }}
      confirm={{
        label: t("common.discardChanges.discard"),
        onClick: onDiscard,
        variant: "destructive",
      }}
    />
  );
}
